import React, { useState, useEffect } from 'react';
import axios from '../../../axiosConfig';
import { Form, Button } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import { useLoading } from '../../../components/LoadingContext';
import { ToastContainer,toast } from 'react-toastify';
import { Card, Row, Col } from 'react-bootstrap'; 
import SelectComponent from '../../../components/SelectComponent';
import { cohortesParaEdicion } from '../../../components/cohorteUtils';



const userId = parseInt(localStorage.getItem('user'));  // ID del usuario logueado



const EditCostoCurso = () => {
  

  const { setLoading } = useLoading();
  const navigate = useNavigate();
  const [curso,setCurso]=useState('');
  const { id } = useParams(); // Obtener el id del curso de la URL

  useEffect(() => {
    setLoading(true);
    Promise.all([getCostoCurso(),handleSeleccionar()]).finally(() => {
        setLoading(false);
    });
}, []);
  const [formData, setFormData] = useState({
    curso_id:id,
    costo_insc:'',
    total:'',
    costo_cuota:'',
    total_cuotas:'',
    num_cuotas:'',
    periodicidad:'',
    grupo:'',
    cohorte:'',
    periodo_id:'',
    centro_id:'',

  });

useEffect(() => {
  const inscripcion = parseFloat(formData.costo_insc) || 0;
  const costo_cuota = parseFloat(formData.costo_cuota) || 0;
  const num_cuotas = parseFloat(formData.num_cuotas) || 0;
  
  setFormData(prevState => ({
    ...prevState,
    total: inscripcion + (costo_cuota*num_cuotas)
  }));
}, [formData.costo_insc, formData.costo_cuota,formData.num_cuotas]);

   const [filterOptions, setFilterOptions] = useState({
      centroOptions: [],
      cohorteOptions: [],
      periodoOptions: [],
      grupoOptions: [],

  });



  const handleSeleccionar = async () => {
    try {
      const token = localStorage.getItem('token');
      
      // Suponiendo que el endpoint unificado sea `/filtros-cursos`
      const response = await axios.get(`/filtros-cursos`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      // Desestructuramos los datos que vienen en la respuesta
      const {periodo,centro,grupo,cohorte} = response.data;
  
      // Retornamos las opciones en un solo objeto
      setFilterOptions( {
        periodoOptions: periodo,
        centroOptions: centro,
        grupoOptions:grupo,
        cohorteOptions:cohorte,
    
      });
  
    } catch (error) {
      console.error('Error fetching filter options:', error);
      
    }
  };


  const getCostoCurso = async () => {
    try {
      let relationsArray = ['curso'];
      const relations = relationsArray.join(',');

      const token = localStorage.getItem('token');
      const response = await axios.get(`/costo-curso/${id}?with=${relations}`, {
      // params: { relations: 'curso' }, // o include: 'curso' según tu backend
      headers: { Authorization: `Bearer ${token}` },
    });
      const curso = response.data;
      setCurso(curso);
      setFormData({
        num_cuotas: curso.num_cuotas || '',
        costo_cuota: curso.costo_cuota || '',
        costo_insc: curso.costo_insc || '',
        periodicidad:curso.periodicidad || '',
        total:curso.total || '',
         grupo:curso.grupo || '',
         cohorte:curso.cohorte || '',
          periodo_id:curso.periodo_id || '',
           centro_id:curso.centro_id || '',
            total_cuotas:curso.total_cuotas || '',
        

      });
    } catch (error) {
      setError('Error fetching course');
      console.error('Error fetching course:', error);
    }
  };

  const [error, setError] = useState(null);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  

  const handleSubmit = async (e) => {
    e.preventDefault();
  
  
  
    try {
      const token = localStorage.getItem('token');
  
      if (!token) {
        toast.error('Error: Token no encontrado');
        return;
      }
  
      // 1. Actualizar los datos del curso
      const formDataWithStatus = {
        ...formData,
        total_cuota: formData.costo_cuota * formData.num_cuotas // Multiplicación de costo_cuota por num_cuotas
      };
      
  
       const cursoResponse = await axios.put(`/costo-curso/${id}`, formDataWithStatus, {
            headers: { Authorization: `Bearer ${token}` },
        });
  
    toast.success('Costo Curso actualizado.');
   
  
       
  
      // Redirigir después de la actualización
      navigate('/cursos');
  
    } catch (error) {
      // Captura cualquier error que ocurra en la solicitud
      toast.error('Error al actualizar curso o petición');
      console.error('Error actualizando:', error);
    }
  };
  



  return (
    <div className="row" style={{ marginTop: '50px' }}>
    <div className="col-lg-6 mx-auto"> {/* Centrado del contenido */}
      <div className="card-box" style={{ padding: '20px', width: '100%', margin: '0 auto' }}>
        <h2 className="mb-2">Actualizar Costo de Curso  {curso?.curso?.descripcion} ({curso?.curso?.cod})</h2>
        <Form onSubmit={handleSubmit} className="custom-gutter">
           <Row className="g-2">
                  <Col md={6}>
              <Form.Group controlId="costo_insc">
                <Form.Label>Costo de Inscripcion ($)</Form.Label>
                <Form.Control
                  type="number"
                  name="costo_insc"
                  value={formData.costo_insc}
                  onChange={handleChange}
                  maxLength={40}
                  min={0}
                />
              </Form.Group>
              </Col>
              <Col md={6}>
              <Form.Group controlId="costo_cuota">
                <Form.Label>Costo de num_cuotas ($)</Form.Label>
                <Form.Control
                  type="number"
                  name="costo_cuota"
                  value={formData.costo_cuota}
                  onChange={handleChange}
                  maxLength={40}
                  min={0}
                />
                </Form.Group>
                </Col>
                </Row>
                <Row className="g-2">
                <Col md={6}>
              <Form.Group controlId="num_cuotas">
                <Form.Label>Número de num_cuotas</Form.Label>
                <Form.Control
                  type="number"
                  name="num_cuotas"
                  value={formData.num_cuotas}
                  onChange={handleChange}
                  maxLength={40}
                  min={0}
                />
              </Form.Group>
              </Col>
              <Col md={6}>
              <Form.Group controlId="periodicidad">
                <Form.Label>Periodicidad (núm de días)</Form.Label>
                <Form.Control
                  type="number"
                  name="periodicidad"
                  value={formData.periodicidad}
                  onChange={handleChange}
                  maxLength={40}
                  min={0}
                />
              </Form.Group>
              </Col>
              </Row>
                <Form.Group controlId="total">
                <Form.Label>Costo Total ($)</Form.Label>
                <Form.Control
                  type="number"
                  name="total"
                  value={formData.total}
                  onChange={handleChange}
                  maxLength={40}
                  readOnly
                />
                </Form.Group>
                <Row className="g-2">
                  <Col md={6}>
                  <SelectComponent
                      options={filterOptions.grupoOptions}  // Usar el estado filterOptions
                      nameField="descripcion"
                      valueField="id"
                      insertValueField="descripcion"
                      selectedValue={formData.grupo}
                      handleChange={handleChange}
                      controlId="grupo"
                      label="Grupo"
                      required
                  />

                  
                  
                  </Col>
                   <Col md={6}>
                  <SelectComponent
                      options={cohortesParaEdicion(filterOptions.cohorteOptions, formData.cohorte)}  // Usar el estado filterOptions
                      nameField="descripcion"
                      valueField="id"
                      insertValueField="descripcion"
                      selectedValue={formData.cohorte}
                      handleChange={handleChange}
                      controlId="cohorte"
                      label="Cohorte"
                      required
                  />
                  
              
                  
                  </Col>


                  </Row>
                  <Row className="g-2">
                  <Col md={6}>
                  <SelectComponent
                      options={filterOptions.periodoOptions}  // Usar el estado filterOptions
                      nameField="descripcion"
                      valueField="id"
                      selectedValue={formData.periodo_id}
                      handleChange={handleChange}
                      controlId="periodo_id"
                      label="Periodo"
                      required
                  />
                  
                  </Col>

                  <Col md={6}>
                  <SelectComponent
                      options={filterOptions.centroOptions}  // Usar el estado filterOptions
                      nameField="descripcion"
                      valueField="id"
                      selectedValue={formData.centro_id}
                      handleChange={handleChange}
                      controlId="centro_id"
                      label="Centro"
                      required
                  />
                  
                  </Col>
                  </Row>



                
  
            
        <div className='mt-3'>
        <Button variant="success" type="submit">
          Guardar
        </Button>
        <Button 
          variant="secondary" 
          onClick={() => navigate('/cursos')}
          className="ms-2"
        >
          Volver
        </Button>
        </div>
      </Form>
    </div>
    </div>
    </div>
  );
};

export default EditCostoCurso;
